import { fetchOffersHistoryExists } from '../../services/offersHistory/fetchOffersHistoryExists';
import { TThunkAction } from '../../types/redux';
import { setOffersHistoryExists } from './actions';

export function getOffersHistoryExists(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      filters: { houseId },
      page: {
        isFromOfferCard,
        queryParams: { offerId },
      },
    } = getState();

    const params = isFromOfferCard && offerId ? { offerId: offerId as number } : { houseId: houseId as number };

    try {
      const res = await fetchOffersHistoryExists(context, params);

      dispatch(setOffersHistoryExists(res));
    } catch (error) {
      dispatch(setOffersHistoryExists(false));
    }
  };
}
